.alignRight {
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.titleAndButtonContainer {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.horizontalRule {
    width: 100%;
}